import styled from 'styled-components/macro';
import { MOBILE_PADDING } from '../Results/constants';

export const StyledAllEvents = styled.div`
  padding: 0 ${MOBILE_PADDING}px;
  .pagination {
    font-size: 12px;
    margin-bottom: 1.6rem;
  }
  .page-link {
    width: 30px;
    height: 30px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.theme.accent};
    border: 0;
    border-radius: 100%;
    overflow: hidden;
  }
  .page-item.active .page-link {
    color: ${(props) => props.theme.purple};
    background-color: ${(props) => props.theme.grey.light};
    border-color: ${(props) => props.theme.grey.light};
  }
  .page-item:first-child .page-link {
    display: none;
  }
  .page-item:last-child .page-link {
    display: none;
  }
  .page-item{
    margin: 0 5px;
  }
`;

export const StyledDateGroup = styled.div`
    font-size: 14px;
    font-weight: 700;
`;
